import { render, staticRenderFns } from "./FormQuestionDescription.vue?vue&type=template&id=72bd0135"
import script from "./FormQuestionDescription.vue?vue&type=script&lang=js"
export * from "./FormQuestionDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports